/**
 * Mirror of /app/backend/vehicle_intelligence.py canonical schema.
 * Keep these in sync.
 */

export const SPEC_FIELDS = [
  { key: 'engine_cc', label: 'Engine Capacity', suffix: ' cc' },
  { key: 'fuel_type', label: 'Fuel Type' },
  { key: 'transmission', label: 'Transmission' },
  { key: 'power_bhp', label: 'Power', suffix: ' bhp' },
  { key: 'torque_nm', label: 'Torque', suffix: ' Nm' },
  { key: 'mileage_kmpl', label: 'Mileage (ARAI)', suffix: ' km/l' },
  { key: 'seating_capacity', label: 'Seating', suffix: ' seater' },
];

export const FEATURE_LABELS = {
  // Comfort
  sunroof: 'Sunroof',
  panoramic_sunroof: 'Panoramic Sunroof',
  cruise_control: 'Cruise Control',
  automatic_climate_control: 'Automatic Climate Control',
  rear_ac_vents: 'Rear AC Vents',
  push_button_start: 'Push Button Start',
  keyless_entry: 'Keyless Entry',
  power_windows: 'Power Windows',
  electric_orvms: 'Electric ORVMs',
  auto_headlamps: 'Auto Headlamps',
  rain_sensing_wipers: 'Rain Sensing Wipers',
  // Infotainment
  touchscreen_infotainment: 'Touchscreen Infotainment',
  android_auto: 'Android Auto',
  apple_carplay: 'Apple CarPlay',
  bluetooth_connectivity: 'Bluetooth Connectivity',
  navigation_system: 'Navigation System',
  voice_commands: 'Voice Commands',
  wireless_charger: 'Wireless Charger',
  premium_audio_system: 'Premium Audio System',
  // Safety
  airbags_count: 'Airbags',
  abs: 'ABS',
  ebd: 'EBD',
  esc: 'ESC (Stability Control)',
  isofix: 'ISOFIX Child Seat Mounts',
  reverse_camera: 'Reverse Camera',
  rear_parking_sensors: 'Rear Parking Sensors',
  front_parking_sensors: 'Front Parking Sensors',
  camera_360: '360° Camera',
  tpms: 'Tyre Pressure Monitor',
  // Exterior
  alloy_wheels: 'Alloy Wheels',
  led_headlamps: 'LED Headlamps',
  led_drls: 'LED DRLs',
  fog_lamps: 'Fog Lamps',
  roof_rails: 'Roof Rails',
  rear_spoiler: 'Rear Spoiler',
};

export const GROUP_TITLES = {
  comfort: 'Comfort & Convenience',
  infotainment: 'Infotainment & Connectivity',
  safety: 'Safety Features',
  exterior: 'Exterior Features',
};

export const GROUP_ORDER = ['comfort', 'infotainment', 'safety', 'exterior'];

export const formatSpec = (value, suffix = '') => {
  if (value === null || value === undefined || value === '') return null;
  return `${value}${suffix}`;
};

/** Yes/No feature; airbags handled specially as a count. */
export const isFeaturePresent = (group, key, value) => {
  if (key === 'airbags_count') {
    const n = Number(value || 0);
    return n >= 2;
  }
  return Boolean(value);
};

/** Build a list of {key, label, isOn, valueLabel} for a feature group. */
export const groupItems = (groupKey, groupData = {}) => {
  return Object.entries(groupData).map(([key, value]) => {
    const isOn = isFeaturePresent(groupKey, key, value);
    let valueLabel = null;
    if (key === 'airbags_count') {
      const n = Number(value || 0);
      valueLabel = n > 0 ? `${n}` : null;
    }
    return {
      key,
      label: FEATURE_LABELS[key] || key,
      isOn,
      valueLabel,
    };
  });
};
